import template from './swag-migration-pause-screen.html.twig';
import './swag-migration-pause-screen.scss';

const { Component } = Shopware;

/**
 * @package services-settings
 */
Component.register('swag-migration-pause-screen', {
    template,
});
